module.exports = __webpack_public_path__ + "static/media/KEBAB-BNB.87b78531.png";